import { useEffect, useMemo, useState } from "react";

// Клиенту показываем 72 часа (с запасом — реально книга живёт дольше).
const STORAGE_HOURS = 72;

const pad = (n) => String(n).padStart(2, "0");

function remainingMs(createdAt) {
  const created = new Date(createdAt).getTime();
  if (!created || Number.isNaN(created)) return null;
  return created + STORAGE_HOURS * 3600 * 1000 - Date.now();
}

const ClockIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" style={{ flexShrink: 0 }}>
    <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2" />
    <path d="M12 7v5l3 2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const InfoIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" style={{ flexShrink: 0 }}>
    <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2" />
    <path d="M12 11v5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    <circle cx="12" cy="8" r="1.2" fill="currentColor" />
  </svg>
);

export default function BookLifetimeChip({ createdAt }) {
  const enabled = true; // таймер показывается всем (без параметра в ссылке)
  const [now, setNow] = useState(Date.now());
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!enabled) return undefined;
    const id = setInterval(() => setNow(Date.now()), 30000);
    return () => clearInterval(id);
  }, [enabled]);

  const label = useMemo(() => {
    const ms = remainingMs(createdAt);
    if (ms == null) return null;
    if (ms <= 0) return "00:00";
    const totalMin = Math.floor(ms / 60000);
    return `${pad(Math.floor(totalMin / 60))}:${pad(totalMin % 60)}`;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [createdAt, now]);

  if (!enabled || label == null) return null;

  const expired = label === "00:00";

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        title="Срок хранения книги"
        style={{
          position: "absolute", top: 12, right: 12, zIndex: 30,
          display: "inline-flex", alignItems: "center", gap: 6,
          padding: "6px 10px", borderRadius: 999,
          border: "1px solid rgba(0,0,0,0.08)",
          background: expired ? "#fdecea" : "rgba(255,255,255,0.92)",
          color: expired ? "#c0392b" : "#333",
          font: "600 13px/1 -apple-system, Segoe UI, Roboto, sans-serif",
          boxShadow: "0 2px 10px rgba(0,0,0,0.10)",
          cursor: "pointer", backdropFilter: "blur(4px)",
          WebkitTapHighlightColor: "transparent",
        }}
      >
        <ClockIcon />
        <span style={{ fontVariantNumeric: "tabular-nums", letterSpacing: "0.02em" }}>{label}</span>
        <span style={{ opacity: 0.55, display: "inline-flex" }}><InfoIcon /></span>
      </button>

      {open && <LifetimeModal onClose={() => setOpen(false)} />}
    </>
  );
}

function LifetimeModal({ onClose }) {
  const [shown, setShown] = useState(false);

  useEffect(() => {
    const raf = requestAnimationFrame(() => setShown(true));
    const onKey = (e) => { if (e.key === "Escape") onClose(); };
    document.addEventListener("keydown", onKey);
    return () => { cancelAnimationFrame(raf); document.removeEventListener("keydown", onKey); };
  }, [onClose]);

  return (
    <div
      onMouseDown={(e) => { if (e.target === e.currentTarget) onClose(); }}
      style={{
        position: "fixed", inset: 0, zIndex: 100000,
        background: "rgba(0,0,0,0.5)", display: "flex",
        alignItems: "center", justifyContent: "center", padding: 16,
        opacity: shown ? 1 : 0, transition: "opacity 0.18s ease",
        WebkitTapHighlightColor: "transparent",
      }}
    >
      <div
        role="dialog"
        aria-modal="true"
        style={{
          width: "100%", maxWidth: 400, background: "#fff",
          borderRadius: 18, boxShadow: "0 20px 60px rgba(0,0,0,0.35)", padding: 24,
          transform: shown ? "translateY(0) scale(1)" : "translateY(8px) scale(0.98)",
          transition: "transform 0.2s cubic-bezier(0.22,1,0.36,1)",
          textAlign: "center",
        }}
      >
        <div style={{ fontSize: 34, marginBottom: 8 }}>⏳</div>
        <div style={{ fontSize: 19, fontWeight: 800, color: "#111", marginBottom: 10 }}>
          Срок хранения макета
        </div>
        <p style={{ fontSize: 15, lineHeight: 1.55, color: "#444", margin: "0 0 8px" }}>
          Макет вашей фотокниги хранится <b>72 часа</b> с момента первого создания.
        </p>
        <p style={{ fontSize: 15, lineHeight: 1.55, color: "#444", margin: "0 0 8px" }}>
          Таймер в левом верхнем углу показывает, сколько времени осталось до удаления.
        </p>
        <p style={{ fontSize: 15, lineHeight: 1.55, color: "#444", margin: "0 0 20px" }}>
          После окончания времени макет будет автоматически удалён <b>без возможности восстановления</b>.
        </p>
        <button
          type="button"
          onClick={onClose}
          style={{
            width: "100%", padding: "12px 18px", borderRadius: 12, border: "none",
            background: "#111827", color: "#fff", fontSize: 15, fontWeight: 700, cursor: "pointer",
          }}
        >
          Ознакомлен(а)
        </button>
      </div>
    </div>
  );
}